import { useAtomValue } from "jotai";

import {
  BorderRadiusOption,
  PrivateTimeSlotCard,
  PublicTimeSlotCard,
} from "@whoosh/design-system/src/apps/PatronApp/screens/teesheet/components/TeeSheet/TimeSlotCard/";
import { Box } from "@whoosh/design-system/src/components/primitive";
import { dateUtils } from "@whoosh/utilities";

import { isBookingMultipleTeeTimesAtom } from "../../../../atoms";
import { RestrictionBlockProps } from "../RestrictionBlock";
import { SlotAvailability } from "../__generated__/TimeSlotListInternalQuery.graphql";
import { RequestTimeSlotRowHeader } from "./RequestTimeSlotRowHeader";

export type RequestTimeSlotRowProps = {
  onSlotPress: (id: string, timeString: string) => void;
  id: string;
  time: string;
  availability: SlotAvailability;
  course: { id?: string; name?: string };
  restriction?: RestrictionBlockProps;
  index: number;
  variant?: "IS_MULTICOURSE_AND_ASSOCIATED_WITH_ALL_COURSES" | "DEFAULT";
  position?: "first" | "last" | "middle" | "only";
  clubVisibility?: "PUBLIC" | "PRIVATE" | "SEMI_PRIVATE";
};

export const RequestTimeSlotRow = ({
  id,
  time,
  restriction,
  index,
  onSlotPress,
  variant,
  course,
  position = "only",
  clubVisibility,
}: RequestTimeSlotRowProps) => {
  const isFirstSlot = index === 0;
  const isLastSlot = index === -1;
  const isBookingMultipleTeeTimes = useAtomValue(isBookingMultipleTeeTimesAtom);

  const timeString = dateUtils.formatHHMM(time) || undefined;

  const onPress = isBookingMultipleTeeTimes
    ? undefined
    : () => onSlotPress(id, time);
  const canUpdate = !isBookingMultipleTeeTimes;

  const borderRadius: { top: BorderRadiusOption; bottom: BorderRadiusOption } =
    {
      top: ["first"].includes(position) ? "2" : "0",
      bottom:
        position === "last" || (position === "only" && isLastSlot) ? "2" : "0",
    };

  return (
    <Box mb={position === "last" ? 2 : 0}>
      {isFirstSlot &&
        restriction &&
        position === "only" &&
        variant === "IS_MULTICOURSE_AND_ASSOCIATED_WITH_ALL_COURSES" && (
          <RequestTimeSlotRowHeader restriction={restriction} />
        )}
      <Box
        mt={1}
        mb={
          isLastSlot &&
          position === "only" &&
          variant === "IS_MULTICOURSE_AND_ASSOCIATED_WITH_ALL_COURSES"
            ? 8
            : 1
        }
      >
        {clubVisibility === "PRIVATE" ? (
          <PrivateTimeSlotCard
            players={[]}
            canUpdate={canUpdate}
            isRequestAvailable={true}
            time={timeString}
            onPress={onPress}
            borderRadius={borderRadius}
            location={course?.name}
          />
        ) : (
          <PublicTimeSlotCard
            time={timeString}
            isRequestAvailable={true}
            borderRadius={borderRadius}
            location={course?.name}
            onPress={onPress}
          />
        )}
      </Box>
    </Box>
  );
};
